const tokens = {
  "colors.splash": {
    "value": "#715CAC",
    "variable": "var(--colors-splash)"
  },
  "colors.purple-primary": {
    "value": "#7548F0",
    "variable": "var(--colors-purple-primary)"
  },
  "colors.purple-1": {
    "value": "#6A4BC0",
    "variable": "var(--colors-purple-1)"
  },
  "colors.purple-2": {
    "value": "#8E68F6",
    "variable": "var(--colors-purple-2)"
  },
  "colors.purple-3": {
    "value": "#BCA4FF",
    "variable": "var(--colors-purple-3)"
  },
  "colors.purple-4": {
    "value": "#C9B9F6",
    "variable": "var(--colors-purple-4)"
  },
  "colors.purple-5": {
    "value": "#E0DEF1",
    "variable": "var(--colors-purple-5)"
  },
  "colors.purple-6": {
    "value": "#F0EEFF",
    "variable": "var(--colors-purple-6)"
  },
  "colors.purple-7": {
    "value": "#F6F5FF",
    "variable": "var(--colors-purple-7)"
  },
  "colors.blue": {
    "value": "#2D59AB",
    "variable": "var(--colors-blue)"
  },
  "colors.blue-1": {
    "value": "#CCDEFF",
    "variable": "var(--colors-blue-1)"
  },
  "colors.blue-2": {
    "value": "#CCDEFF",
    "variable": "var(--colors-blue-2)"
  },
  "colors.orange": {
    "value": "#FC8210",
    "variable": "var(--colors-orange)"
  },
  "colors.orange-1": {
    "value": "#FFC997",
    "variable": "var(--colors-orange-1)"
  },
  "colors.orange-2": {
    "value": "#FFDDBD",
    "variable": "var(--colors-orange-2)"
  },
  "colors.orange-3": {
    "value": "#FEF3E9",
    "variable": "var(--colors-orange-3)"
  },
  "colors.red": {
    "value": "#E34C4C",
    "variable": "var(--colors-red)"
  },
  "colors.red-1": {
    "value": "#FC6B6B",
    "variable": "var(--colors-red-1)"
  },
  "colors.red-2": {
    "value": "#FFE5E5",
    "variable": "var(--colors-red-2)"
  },
  "colors.red-3": {
    "value": "#FFE8E8",
    "variable": "var(--colors-red-3)"
  },
  "colors.green": {
    "value": "#0DC277",
    "variable": "var(--colors-green)"
  },
  "colors.green-1": {
    "value": "#068F61",
    "variable": "var(--colors-green-1)"
  },
  "colors.green-2": {
    "value": "#2DAB77",
    "variable": "var(--colors-green-2)"
  },
  "colors.green-3": {
    "value": "#CAEDDA",
    "variable": "var(--colors-green-3)"
  },
  "colors.green-4": {
    "value": "#E9FEF5",
    "variable": "var(--colors-green-4)"
  },
  "colors.pink": {
    "value": "#F04866",
    "variable": "var(--colors-pink)"
  },
  "colors.pink-1": {
    "value": "#FFD0D9",
    "variable": "var(--colors-pink-1)"
  },
  "colors.pink-2": {
    "value": "#FEE9F1",
    "variable": "var(--colors-pink-2)"
  },
  "colors.yellow": {
    "value": "#D9AA04",
    "variable": "var(--colors-yellow)"
  },
  "colors.yellow-1": {
    "value": "#FFF4CF",
    "variable": "var(--colors-yellow-1)"
  },
  "colors.black": {
    "value": "#3C3C3C",
    "variable": "var(--colors-black)"
  },
  "colors.black-1": {
    "value": "#646464",
    "variable": "var(--colors-black-1)"
  },
  "colors.black-2": {
    "value": "#787878",
    "variable": "var(--colors-black-2)"
  },
  "colors.black-3": {
    "value": "#A0A0A0",
    "variable": "var(--colors-black-3)"
  },
  "colors.black-4": {
    "value": "#B6B6B6",
    "variable": "var(--colors-black-4)"
  },
  "colors.black-5": {
    "value": "#BCBCBCB2",
    "variable": "var(--colors-black-5)"
  },
  "colors.gray": {
    "value": "#C2C2C2",
    "variable": "var(--colors-gray)"
  },
  "colors.gray-1": {
    "value": "#D9D9D9",
    "variable": "var(--colors-gray-1)"
  },
  "colors.gray-2": {
    "value": "#EBEBEB",
    "variable": "var(--colors-gray-2)"
  },
  "colors.gray-3": {
    "value": "#F4F4F4",
    "variable": "var(--colors-gray-3)"
  },
  "colors.gray-4": {
    "value": "#FAFAFA",
    "variable": "var(--colors-gray-4)"
  },
  "colors.white": {
    "value": "#FFF",
    "variable": "var(--colors-white)"
  },
  "colors.delayLinear": {
    "value": "linear-gradient(90.71deg, #FFE8E8 5.64%, rgba(254, 238, 238, 0.31) 96.94%);",
    "variable": "var(--colors-delay-linear)"
  },
  "colors.purpleLinear": {
    "value": "linear-gradient(90.64deg, #F1F0F8 1.9%, rgba(240, 239, 252, 0.403547) 62.33%, rgba(240, 238, 255, 0) 103.21%);",
    "variable": "var(--colors-purple-linear)"
  },
  "fontSizes.xxs": {
    "value": "8px",
    "variable": "var(--font-sizes-xxs)"
  },
  "fontSizes.xs": {
    "value": "10px",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "11px",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "12px",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "14px",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "16px",
    "variable": "var(--font-sizes-xl)"
  },
  "shadows.cardShadow": {
    "value": "0px 4px 8px 0px #BFBFBF1A",
    "variable": "var(--shadows-card-shadow)"
  },
  "shadows.headerShadow": {
    "value": "0px 4px 8px 0px #BCBCBC26",
    "variable": "var(--shadows-header-shadow)"
  },
  "fonts.iranYekan": {
    "value": "var(--font-iran-yekan), sans-serif",
    "variable": "var(--fonts-iran-yekan)"
  },
  "fonts.iranYekanBold": {
    "value": "var(--font-iran-yekan-bold), sans-serif",
    "variable": "var(--fonts-iran-yekan-bold)"
  },
  "zIndex.layout": {
    "value": 1,
    "variable": "var(--z-index-layout)"
  },
  "zIndex.modal": {
    "value": 2,
    "variable": "var(--z-index-modal)"
  },
  "zIndex.toast": {
    "value": 3,
    "variable": "var(--z-index-toast)"
  },
  "zIndex.map-extension": {
    "value": 400,
    "variable": "var(--z-index-map-extension)"
  },
  "zIndex.camera": {
    "value": 4,
    "variable": "var(--z-index-camera)"
  },
  "zIndex.camera-layout": {
    "value": 5,
    "variable": "var(--z-index-camera-layout)"
  },
  "sizes.maxContainer": {
    "value": "450px",
    "variable": "var(--sizes-max-container)"
  },
  "sizes.breakpoint-2xl": {
    "value": "1536px",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "sizes.breakpoint-sm": {
    "value": "375px",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "390px",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "412px",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "450px",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "radii.none": {
    "value": "0px",
    "variable": "var(--radii-none)"
  },
  "radii.small": {
    "value": "4px",
    "variable": "var(--radii-small)"
  },
  "radii.medium": {
    "value": "8px",
    "variable": "var(--radii-medium)"
  },
  "radii.large": {
    "value": "16px",
    "variable": "var(--radii-large)"
  },
  "radii.rounded": {
    "value": "9999px",
    "variable": "var(--radii-rounded)"
  },
  "breakpoints.2xl": {
    "value": "1536px",
    "variable": "var(--breakpoints-2xl)"
  },
  "breakpoints.sm": {
    "value": "375px",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "390px",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "412px",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "450px",
    "variable": "var(--breakpoints-xl)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar